"use strict";

var _               = require("underscore");

var BaseModel       = require("@immanens-com/pv5js/common/models/base-model");


/**
 * RetronewsPageSemanticModel :  all semantics informations extracted by syllabs + page blocks
 */
module.exports= BaseModel.extend({

    pv5api:null,

    defaults: {
        id:0,
        publicationId:0,
        readability:0,
        documentId:0,
        entities:null,
        width:0,
        height:0,
        blocks:null,
        articles:null
    },

    urlRoot:function(){
        return this.pv5api+"/document/"+this.get("publicationId")+"/"+this.get("documentId")+"/page-semantic";
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        _.extend(this, options);
    },


    /**
     * retrieve text block
     * @param  {[type]} block_id [description]
     * @return {[type]}          [description]
     */
    block:function(block_id){
        return _.findWhere(this.get("blocks"),{id:block_id});
    },

    article:function(article_id){
        return _.findWhere(this.get("articles"),{id:article_id});
    },

    /**
     * small adjustment: the server returns the response from syllabs as is, we cut multipage behaviour
     * @param  {Object} data
     * @return {Object}
     */
    parse:function(data){
        var d={};
        if(data.documents&&data.documents.length&&data.documents[0].pages&&data.documents[0].pages.length){
            d=data.documents[0].pages[0];
            if(d.articles && d.articles.page){
                d.articles=d.articles.page;
            }
            else{
                d.articles = [];
            }
            delete(d.id);
        }
        return d;
    }

});